import { Injectable } from '@angular/core';
import { CreateBusiness } from '@fnModels/business';
import { Address } from '@models/address';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Api } from '../api.service';
import { environment } from '../../../../environments/environment';
import {
	BusinessSettingsVisibleTemplates,
	MatterDocumentFlows,
} from '@models/documents';
import { BusinessSignUpRequestTags } from '@models/businessSignUpRequests';

interface CreateBusinessResponse {
	businessId: string;
	addressId: string;
}

@Injectable({
	providedIn: 'root',
})
export class BusinessService extends Api {
	private basePath = `${environment.api.baseUrl}/business`;

	constructor(private http: HttpClient) {
		super(http);
	}

	// rome-ignore lint/suspicious/noExplicitAny: <explanation>
	create = (
		name: string,
		address: Address,
		newMatterDocumentFlows: MatterDocumentFlows,
		visibleTemplates: BusinessSettingsVisibleTemplates,
		tags: BusinessSignUpRequestTags,
	): Observable<CreateBusinessResponse> => {
		const newBusinessModelRequest: CreateBusiness = {
			name,
			address: {
				...address,
				GeoLocation: address._geoloc,
				AdminAreas: address.admin_areas,
			} as typeof address & { GeoLocation: (typeof address)['_geoloc'] } & {
				AdminAreas: (typeof address)['admin_areas'];
			},
			newMatterDocumentFlows,
			visibleTemplates,
			tags,
		};

		return this.http.post<CreateBusinessResponse>(
			this.basePath,
			newBusinessModelRequest,
		);
	};
}
